import { CSSProperties } from "@material-ui/core/styles/withStyles";
import {createStyles, Theme} from "@material-ui/core";
import {blueBackgroundColor, buttonContainedLarge, buttonOutlinedLarge, greyInput, primaryColor, secondaryColor, styleColors, typography, YELLOW} from "src/main.style";

export const chatBottomBar:CSSProperties = {
  display: 'flex',
  minWidth:'100vw',
  maxWidth:'100vw',
  backgroundColor: styleColors.greyLight2,
  borderTop: `0.5px solid ${styleColors.greyMedium1}`,
  padding: '8px 12px 30px',
  boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
  alignItems: 'flex-end',
  boxSizing: 'border-box',
  gap:'8px',
  zIndex: 1,
}

export const   chatInputBox :CSSProperties = {
  flexGrow: 1,
  backgroundColor: styleColors.white,
  padding: '3px',
  display: 'flex',
  borderRadius: '8px',
  border: `0.5px solid ${styleColors.greyMedium1}`,
  minHeight: '40px',
  boxSizing: 'border-box',
  alignItems: 'center',
  flexDirection: 'column',
  overflow:'hidden',
}

export const   chatFiles :CSSProperties = {
  flexGrow: 1,
  borderWidth: '0px',
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  overflowY: 'hidden',
  display: 'flex',
  maxWidth: '100%',
  alignSelf: 'flex-start',
}
export const ChatStyle = (theme: Theme) => createStyles({
  buttonOutlinedLarge,
  buttonContainedLarge,
  greyInput,
  error : {
    color: primaryColor,
    fontSize: '10px',
    fontWeight: 600,
    maxHeight: '0px',
    lineHeight: '12px',
    overflow: 'hidden',
    transition: 'all 0.3s',
    margin:'20px', marginTop:0
  },
  backSwipe : {
    minHeight: 'calc(100vh - 134px)',
    width: '15px',
    position: 'absolute',
    top:'54px',
    left:0,
  },
  chatListItem : {
    display: 'flex',
    minHeight: '80px',
    maxHeight: '80px',
    transition: 'all 0.2s',
    overflow: 'hidden',
  },
  chatListItemIcon : {
    display: 'flex',
    minHeight: '80px',
    maxHeight: '80px',
    minWidth: '100px',
    maxWidth: '100px',
    // alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '12px',
    
  },
  chatListItemBody : {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
  },
  chatListItemTopRow : {
    display: 'flex',
    // paddingTop: '6px',
    alignItems: 'baseline',
  },
  chatListItemBottomRow : {
    display: 'flex',
    paddingTop: '2px',
  },
  chatListItemTitle : {
    flexGrow:1,
    fontSize: '16px',
    fontWeight: 500,
    paddingTop: '6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  chatListItemTime : {
    display: 'flex',
    paddingRight: '18px',
    fontWeight: 300,
    fontSize: '14px',
    color:styleColors.greyDark1,
    paddingLeft: '4px',
    textWrap: 'nowrap',
  },
  chatListItemMessage : {
    flexGrow: 1,
    paddingTop: '4px',
    fontWeight:300,
    maxHeight:'40px',
    color:styleColors.greyDark1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
  },
  chatListItemBadge : {
    display: 'flex',
    paddingRight: '18px',
    paddingLeft: '4px',
  },
  icon : {
    minHeight: '56px',
    maxHeight: '56px',
    minWidth: '56px',
    maxWidth: '56px',
    backgroundColor: secondaryColor+"54",
    borderRadius:'100px',
    boxSizing: 'border-box',
    display: 'flex',
    placeContent: 'center',
    overflow:'hidden',
    position: 'relative',
    border:`1px solid ${styleColors.blackAlpha18}`,
  },
  imageIcon : {
    width: '100%',
    height: '100%',
    objectFit: 'cover',     /* scales & crops image to fill box */
    objectPosition: 'center', /* centers the crop on the image’s middle */
    display: 'block',        /* remove inline‐img whitespace */
  },
  iconSmall : {
    minHeight: '40px',
    maxHeight: '40px',
    minWidth: '40px',
    maxWidth: '40px',
    backgroundColor: secondaryColor+"54",
    boxSizing: 'border-box',
    borderRadius:'100px',
    display: 'flex',
    placeContent: 'center',
    overflow:'hidden',
    position: 'relative',
    border:`1px solid ${styleColors.blackAlpha18}`,
  },
  badge : {
    color: styleColors.white,
    alignSelf: 'center',
    padding: '2px 6px',
    fontSize: '16px',
    minWidth: '20px',
    boxSizing: 'border-box',
    textAlign: 'center',
    borderRadius: '100px',
    backgroundColor: primaryColor,
    transition: 'scale 0.2s'
  },
  chatFooter : {
    minHeight: '76px',
    maxHeight: '76px',
    zIndex: 10,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    backgroundColor: styleColors.greyLight2,
    borderTop: `0.5px solid ${styleColors.greyMedium1}`,
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    overflow: 'hidden',
    transition: 'all 0.5s',
    boxSizing: 'border-box',
    justifyContent: 'space-evenly',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 12px',
    paddingBottom: '20px',
  },
  FAB : {
    position: 'absolute',
    bottom: '100px',
    minWidth: '62px',
    minHeight: '62px',
    right: '20px',
    backgroundColor: styleColors.greyLight2,
    zIndex: 2,
    borderRadius: '100px',
    transition: 'all 0.5s',
    boxShadow : `0px 3px 30px ${styleColors.fabShadow}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  FABLeft : {
    right: 'unset',
    left: '20px',
  },
  FABHidden : {
    scale:0, 
    pointerEvents:'none', 
    opacity:0,
  },
  // Gives an icon button the FAB look: no padding of its own and no hover tint over the background.
  FABButton : {
    padding: 0,
    '&:hover': {
      backgroundColor: styleColors.greyLight2,
    },
  },
  chatBottomBar,
  chatInputBox,
  chatInput : {
    flexGrow: 1,
    padding: '3px',
    borderWidth: '0px',
  },
  chatFiles,
  chatfileContainer : {
    position:'relative',
    margin: '4px',
    flexShrink: 0,
    cursor: 'pointer',
  },
  chatFileCard : {
    position: 'relative',
    width: '168px',
    height: '60px',
    boxSizing: 'border-box',
    padding: '8px 28px 8px 8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: styleColors.greyLight1,
    border: `1px solid ${styleColors.greyMedium1}`,
    borderRadius: '8px',
    overflow: 'hidden',
  },
  chatFileTypeBadge : {
    flexShrink: 0,
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: styleColors.white,
  },
  chatFileDetails : {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    gap: '2px',
  },
  chatFileName : {
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '16px',
    color: styleColors.primaryTextBlack87,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chatFileMeta : {
    fontSize: '11px',
    lineHeight: '14px',
    color: styleColors.blackAlpha63,
    whiteSpace: 'nowrap',
  },
  chatFileProgressTrack : {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '3px',
    backgroundColor: styleColors.greyMedium1,
  },
  chatFileProgressBar : {
    height: '100%',
    backgroundColor: primaryColor,
    transition: 'width 0.2s ease-out',
  },
  chatFileOverLay : {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatFileClose : {
    position: 'absolute',
    top: '4px',
    right: '4px',
    zIndex: 1,
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)', // fixed colors so the chip reads on image previews in both themes
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  chatFileImage : {
    maxWidth: '100px',
    maxHeight: '60px',
    borderRadius: '8px',
    display: 'block',
  },
  chatTopBar : {
    display: 'flex',
    minHeight: '65px',
    maxHeight: '65px',
    overflow:'hidden',
    minWidth:'100vw',
    maxWidth:'100vw',
    backgroundColor: styleColors.greyLight2,
    boxSizing: 'border-box',
    alignItems: 'flex-start',
  },
  chatTopBarHeader : {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    minHeight: '54px',
    alignItems: 'center',
  },
  chatTopBarIcon : {
    display: 'flex',
    paddingRight: '10px',
  },
  chatTopBarBackBody : {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  chatTopBarBackTitle : {
    fontSize: '18px',
    fontWeight:600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  chatTopBarBackSubtitle : {
    fontSize: '14px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  chatRoom : {
    display:'flex',
    minWidth:'100vw',
    maxWidth:'100vw',
    overflowX:'hidden',
    overflowY:'auto',
    flexGrow:1,
    flexDirection:'column',
    
  },
  chatMessages : {
    display:'flex',
    minWidth:'100vw',
    maxWidth:'100vw',
    overflowX:'hidden',
    overflowY:'auto',
    borderRadius: '32px 32px 0px 0px',
    backgroundColor: blueBackgroundColor,
    flexGrow:1,
    flexDirection:'column-reverse',
    position:'relative',
    paddingTop: '20px',
    transition: 'padding-bottom 0.3s',
    boxShadow: `0px 0px 20px ${styleColors.blackAlpha12}`,
  },
  chatMessagesBlackout : {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.scrimBlack63,
    zIndex: 2,
    transition: 'opacity 0.3s'
  },
  // Above a selected message (zIndex 3) and the bottom bar.
  chatToxicSheetBackdrop : {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.scrimBlack63,
    zIndex: 4,
    transition: 'opacity 0.3s',
  },
  chatToxicSheetBackdropClosed : {
    opacity: 0,
    pointerEvents: 'none',
  },
  // A bottom sheet like the one shared notes are edited in.
  chatToxicSheet : {
    position: 'fixed',
    left: 0,
    bottom: 0,
    width: '100%',
    maxHeight: '90%',
    zIndex: 5,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    backgroundColor: styleColors.white,
    borderRadius: '32px 32px 0px 0px',
    boxShadow: `0px -1px 23px ${styleColors.blackAlpha23}`,
    color: styleColors.primaryTextBlack87,
    transition: 'transform 0.3s',
    animation: '$chatToxicSheetIn 0.3s',
  },
  chatToxicSheetClosed : {
    transform: 'translateY(100%)',
    pointerEvents: 'none',
  },
  '@keyframes chatToxicSheetIn': {
    '0%': { transform: 'translateY(100%)' },
    '100%': { transform: 'translateY(0)' },
  },
  chatToxicSheetHandle : {
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0,
    padding: '12px 0px 20px',
    touchAction: 'none',
  },
  chatToxicSheetHandleBar : {
    minWidth: '120px',
    minHeight: '3px',
    backgroundColor: styleColors.lightGreyOverlay,
    borderRadius: '4px',
  },
  chatToxicSheetContent : {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    maxWidth: '600px',
    minHeight: 0,
    margin: '0px auto',
    padding: '0px 24px calc(24px + env(safe-area-inset-bottom, 0px))',
    boxSizing: 'border-box',
    overflowY: 'auto',
  },
  chatToxicSheetTitle : {
    ...typography.heading4,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  chatToxicSheetIcon : {
    color: YELLOW,
    fontSize: '36px',
    flexShrink: 0,
  },
  chatToxicSheetInfo : {
    ...typography.body1,
    color: styleColors.greyDark1,
  },
  // Reads as part of the sentence it sits in.
  chatToxicSheetArticleLink : {
    color: 'inherit',
    letterSpacing: 'inherit',
    '&:hover': {
      backgroundColor: styleColors.transparent,
    },
  },
  chatToxicSheetSuggestion : {
    ...typography.body1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flexShrink: 0,
    maxHeight: '200px',
    overflowY: 'auto',
    padding: '12px',
    border: `1px solid ${styleColors.greyMedium1}`,
    borderRadius: '8px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  // Takes the place of the suggestion when the AI could not give one.
  chatToxicSheetNoSuggestion : {
    ...typography.body1,
    flexShrink: 0,
    padding: '12px',
    border: `1px dashed ${styleColors.greyMedium1}`,
    borderRadius: '8px',
    color: styleColors.greyDark1,
    fontStyle: 'italic',
  },
  chatToxicSheetSuggestionLabel : {
    fontSize: '12px',
    fontWeight: 600,
  },
  chatToxicSheetActions : {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  chatToxicSheetAction : {
    padding: '10px 22px',
  },
  chatReactionBar : {
    position: 'absolute',
    bottom: 'calc(100% + 6px)',
    left: '44px',
    backgroundColor: styleColors.white,
    padding: '4px',
    borderRadius: '99px',
    fontSize: '24px',
    border: `1px solid ${styleColors.greyMedium1}`,
    maxWidth: 'calc(100% - 92px)',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    overflow: 'scroll',
    transition: 'all 0.3s',
  },
  chatReactionBarButton : {
    padding: '0px 4px',
  },
  chatActionBar : {
    position: 'absolute',
    top: 'calc(100% + 6px)',
    maxWidth: 'calc(100% - 92px)',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    overflow: 'scroll',
    transition: 'all 0.3s',
    gap: '12px',
  },
  chatActionBarButton : {
    borderRadius: '99px',
    backgroundColor: styleColors.white,
    padding: '6px 16px',
    border: `1px solid ${styleColors.greyMedium1}`,
    fontSize: '14px',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '4px',
    color: styleColors.primaryTextBlack87,
    fontWeight: 600,
  },
  // Gives the shared Button the look of the pills beside it in the action bar.
  chatActionBarSharedButton : {
    minWidth: 0,
    fontFamily: 'inherit',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    '&:hover': {
      backgroundColor: styleColors.white,
    },
  },
  // The message a reply answers, quoted on one line: above the reply's text, or above the input while writing one.
  chatReplyQuote : {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: 0,
    marginBottom: '6px',
    paddingLeft: '8px',
    borderLeft: `2px solid ${styleColors.greyMedium1}`,
    fontSize: '12px',
    lineHeight: '16px',
    color: styleColors.greyMedium2,
  },
  chatReplyBar : {
    alignSelf: 'stretch',
    margin: '3px 0 0 3px',
    borderLeftColor: primaryColor,
    fontSize: '13px',
  },
  chatReplyLabel : {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  chatReplyText : {
    flexGrow: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chatReplyClose : {
    flexShrink: 0,
    padding: '2px',
  },
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  menuListItem: {
    ...typography.input,
    '&.Mui-disabled': {
      opacity: 0.72,
    },
  },
  menuItemTitle : {
    fontSize: '14px',
    fontWeight: 400,
    whiteSpace: 'normal',
    display:'flex',
    alignItems: 'center',
  },
  chatMessage : {
    display: 'flex',
    position: 'relative',
    userSelect: 'none',
    WebkitUserSelect : 'none',
  },
  chatTime : {
    position: 'absolute',
    bottom: '-14px',
    fontSize: '10px',
    textWrap: 'nowrap',
  },
  chatMessageWithReadInfo: {
    flexWrap: 'wrap',
  },
  chatTimeWithReadInfo: {
    position: 'static',
    display: 'inline',
    textWrap: 'wrap',
    overflowWrap: 'anywhere',
    lineHeight: '14px',
  },
  chatReadInfo: {
    flexBasis: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    padding: '0 48px',
    marginTop: '-12px',
    marginBottom: '2px',
  },
  chatLink : {
    overflow: 'hidden',
    wordWrap: 'break-word',
  },
  chatMessageIcon : {
    display: 'flex',
    padding: '0px 8px',
    alignItems: 'self-end',
    minWidth:'28px',
    position: 'relative',
  },
  chatMessageDownloadLink : {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    padding: 0,
    border: 'none',
    backgroundColor: styleColors.transparent,
    color: styleColors.blackAlpha45,
    opacity: 0.72,
    textDecoration: 'none',
    cursor: 'pointer',
    zIndex: 1,
    transition: 'opacity 0.2s, color 0.2s',
    '&:hover': {
      color: styleColors.blackAlpha63,
      opacity: 1,
    },
    '& svg': {
      fontSize: '24px',
      fill: 'currentColor',
    },
  },
  chatMessageMsg : {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'calc(100% - 100px)',
    background: styleColors.white,
    border: `1px solid ${styleColors.greyMedium1}`,
    padding: '12px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    marginBottom: '2px',
    position:'relative',
    minWidth: '55px',
    color: styleColors.greyDark1,
    fontWeight: 300,
    fontSize: '16px',
  },
  chatMessageMsgLastRight: {
    position: 'relative', // required for proper absolute positioning
    marginBottom: '14px',
    borderRadius: '8px 8px 0px 8px',
    "&:after": { // Border arrow (outer triangle)
      right: '-6px',
      width: '6px',
      bottom: '-1px',
      height: '9px',
      content: "''",
      position: 'absolute',
      clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
      background: styleColors.greyMedium1,
    },
    "&:before": { // White arrow (inner triangle)
      right: '-4.5px',
      width: '4.5px',
      bottom: '0px',
      height: '6.5px',
      content: "''",
      zIndex: 1,
      position: 'absolute',
      clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
      background: styleColors.white,
    }
  },
  chatMessageMsgLastLeft: {
    position: 'relative', // required for proper absolute positioning
    marginBottom: '14px',
    borderRadius: '8px 8px 8px 0px', // bottom left corner set to 0 for left arrow
    "&:after": { // Border arrow (outer triangle)
      left: '-6px',
      width: '6px',
      bottom: '-1px',
      height: '9px',
      content: "''",
      position: 'absolute',
      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
      background: styleColors.greyMedium1,
    },
    "&:before": { // White arrow (inner triangle)
      left: '-4.5px',
      width: '4.5px',
      bottom: '0px',
      height: '6.5px',
      content: "''",
      position: 'absolute',
      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
      background: styleColors.white,
      zIndex: 1,
    }
  },
  chatMessageMsgReaction: {
    marginBottom: '14px',
  },
  chatMessageBadAlternative : {
    opacity:0.5,
  },
  chatMessageSpace : {
    flexGrow:1,
  },
  chatIconAvatar : {
    minHeight: '28px',
    maxHeight: '28px',
    minWidth: '28px',
    maxWidth: '28px',
    backgroundColor: styleColors.greyMedium1,
    borderRadius:'28px',
  },
  chatMessageSender : {
    position: 'absolute',
    fontSize: '10px',
    fontWeight:400,
    top: '-14px',
    right: '16px',
    color: styleColors.greyMedium2,
  },
  chatImage : {
    display:'flex',
  },
  chatMessageInfo : {
    display:'flex',
    fontSize:'12px',
    width: '100%',
    justifyContent: 'center',
    padding: '12px',
    color: styleColors.greyMedium2,
  },
  greyIcon : {
    fontSize: '30px',
    fill: styleColors.blackAlpha63,
  },
  chatSuggestion : {
    display:'flex',
    alignItems: 'center',
    gap: '8px',
  },
  chatSuggestionIcon : {
    backgroundColor: styleColors.white,
  },
  editChat : {
    display: 'flex',
    flexDirection: 'column',
  },
  editActions : {
    display: 'flex',
    gap: '20px',
    padding: '20px',
  },
  editIcon : {
    minWidth:'128px',
    maxWidth:'128px',
    minHeight:'128px',
    maxHeight:'128px',
    backgroundColor: secondaryColor+"54",
    borderRadius:'200px',
    placeContent: 'center',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    overflow:'hidden',
    border:`1px solid ${styleColors.blackAlpha18}`,
  },
  editParticipant : {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '10px 20px',
  },
  editParticipantName : {
    fontSize: '20px',
    flex:1,
  },
  editIconImg : {
    width:'128px',
    height:'128px',
    objectFit: 'cover',     /* same scale & crop as imageIcon in the chat list */
    objectPosition: 'center',
    display: 'block',
  },
  bigDialog : {
    overflowX: 'hidden',
    minWidth: 'calc(100vw - 48px)',
    position: 'relative',
  },
  callInfo: {
    display:'flex',
    flexDirection:'column',
    gap:'6px',
  },
  callTitle:{
    fontWeight: 600
  },
  chatWorking: {
    position: 'relative',
    display: 'inline-block',
    color: styleColors.greyMedium2, // base text color
    overflow: 'hidden',

    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: `linear-gradient(120deg, ${styleColors.transparent}, ${styleColors.whiteShimmer60}, ${styleColors.transparent})`,
      animation: '$shimmer 2s infinite',
    },
  },

  '@keyframes shimmer': {
    '0%': { left: '-100%' },
    '100%': { left: '100%' },
  },
  // Holds the input box and the polish button that floats above its right edge.
  chatInputArea: {
    position: 'relative',
    flexGrow: 1,
    display: 'flex',
    minWidth: 0,
  },
  polishButton: {
    position: 'absolute',
    right: 0,
    bottom: 'calc(100% + 14px)',
    zIndex: 2,
    minHeight: '30px',
    padding: '3px 12px',
    borderRadius: '100px',
    backgroundColor: styleColors.greyLight2,
    border: `0.5px solid ${styleColors.greyMedium1}`,
    boxShadow: `0px 2px 8px ${styleColors.chromePurpleShadow}`,
    color: styleColors.greyDark2,
    textTransform: 'none',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: styleColors.greyLight2,
    },
    '&.Mui-disabled': {
      backgroundColor: styleColors.greyLight2,
      color: styleColors.greyMedium2,
    },
  },
  polishFailed: {
    color: styleColors.materialRed,
  },
  polishWorking: {
    color: styleColors.greyMedium2,
    fontStyle: 'italic',
    animation: '$polishPulse 1.4s ease-in-out infinite',
  },
  '@keyframes polishPulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.35 },
    '100%': { opacity: 1 },
  },
});



// WEBPACK FOOTER //
// ./src/components/chat/Chat.style.ts